/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.ReportingHierarchy {
    "use strict";

    export class ReportingHierarchyContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {

        constructor(appSettings: Meevo.Components.Common.IAppSettings,
                    dataService: Meevo.Components.BaseClasses.IDataService,
                    modalService: Meevo.Components.Modal.IModalService,
                    identityService: Meevo.Components.Common.IIdentityService,
                    loggingService: Meevo.Components.Logging.ILoggingService,
                    securityChecker: Meevo.Components.Common.ISecurityService,
                    trackingService: Meevo.Components.Tracking.ITrackingService,
                    protected $q: angular.IQService) {

            super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService);

            this.baseEndpoint = appSettings.API_ENDPOINTS.reportingHierarchy;
            this.sectionTemplatePath = "app/plugins/reportingHierarchy/sectionViews/";

            this.entityType = 'ReportingHierarchy';
        }

        initializeSections(): void {
            const baseSectionProps: Meevo.Model.ISectionParamsBaseDataService = {
                sectionId: 1,
                displayNameContentKey: '',
                template: '',
                isPrimarySection: true,
                handlesOwnCrud: false,
                baseEndpoint: this.appSettings.API_ENDPOINTS.reportingHierarchy,
                sectionEndpoint: "",
                loggingService: this.loggingService,
                dataService: this.dataService,
                identityService: this.identityService,
                noun: Meevo.Model.NounEnum.ReportingHierarchy,
                appSettings: this.appSettings,
                sectionSecurityKey:''
            };


            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.BUSINESSINFO_REPORTHIERARCHY_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new MainSection(_.extend({}, baseSectionProps, {
                    sectionId: 1,
                    displayNameContentKey: "SECTION_REPORTING_HIERARCHY_MAIN",
                    template: "main.html",
                    sectionSecurityKey: this.securityKeys.BUSINESSINFO_REPORTHIERARCHY_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ
                })));
            }

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.BUSINESSINFO_REPORTHIERARCHY_TAB_DESIGNHIERARCHY + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new DesignHierarchySection(_.extend({}, baseSectionProps, {
                    sectionId: 2,
                    displayNameContentKey: "SECTION_DESIGN_HIERARCHY",
                    template: "designHierarchy.html",
                    modalService: this.modalService,
                    sectionSecurityKey: this.securityKeys.BUSINESSINFO_REPORTHIERARCHY_TAB_DESIGNHIERARCHY + Meevo.Components.Common.SecurityParts.KEY_PART_READ
                })));
            }

           if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.BUSINESSINFO_REPORTHIERARCHY_TAB_SETLOCATIONS + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new SetLocationsSection(_.extend({}, baseSectionProps, {
                    sectionId: 3,
                    displayNameContentKey: "SECTION_SET_LOCATIONS",
                    template: "setLocations.html",
                    sectionSecurityKey: this.securityKeys.BUSINESSINFO_REPORTHIERARCHY_TAB_SETLOCATIONS + Meevo.Components.Common.SecurityParts.KEY_PART_READ
                })));
           }
        }

        get showCopy(): boolean {
            return false;
        }

        get showDelete(): boolean {
            return false;
        }

        selectSection(item): void {
            switch (item.sectionId) {
                case 2:
                    this.buildCrudSecurityKeysBase(this.securityKeys.BUSINESSINFO_REPORTHIERARCHY_TAB_DESIGNHIERARCHY);
                    break;
                case 3:
                    this.buildCrudSecurityKeysBase(this.securityKeys.BUSINESSINFO_REPORTHIERARCHY_TAB_SETLOCATIONS);
                    break;
                default:
                    this.buildCrudSecurityKeysBase(this.securityKeys.BUSINESSINFO_REPORTHIERARCHY_TAB_MAIN, true, true, false, true);
                    break;
            }
            super.selectSection(item);
        }

        activateLocationsSection(nodeId) {
            const section = this.sections.filter((s: any) => s instanceof SetLocationsSection)[0] as SetLocationsSection;
            if (section) {
                this.selectSection(section);
                this.mode = Model.MaintenanceFormState.Editing;
                section.selectedNode = nodeId;
                section.fromShortcut = true;
            }
        }

        activateDesignSection() {
            const section = this.sections.filter((s: any) => s instanceof DesignHierarchySection)[0] as DesignHierarchySection;
            if (section) {
                this.selectSection(section);
            }
        }

        cancel() {
            super.cancel();

            const section = this.selectedSection;

            if (section instanceof SetLocationsSection && section.fromShortcut) {
                section.fromShortcut = false;
                this.activateDesignSection();
            }

        }

        save(): ng.IPromise<any> {

            if (this.selectedSection instanceof DesignHierarchySection) {

                let section = this.selectedSection as DesignHierarchySection;

                section.preSave();

                let errors = section.validate();

                if (errors.length > 0) {
                    this.modalService.alert(errors[0].message);
                    return this.$q.reject(errors[0].message);
                };

                this.loadingInProgress = true;

                return this.dataService.customMethodData(`/${this.appSettings.API_ROOT}/${this.baseEndpoint}Tree`, 'POST', section.serialize())
                    .then(({data}) => {
                        section.model = data;
                        section.nodes = data.branches;
                        this.mode = Meevo.Model.MaintenanceFormState.Readonly;
                        this.loggingService.trace(`Tree saved.`);
                        this.postUpdate(section.model);
                        section.populate();
                        section.takeNodesBackup();
                    })
                    .catch((reason: any) => {
                        this.loggingService.trace('Item not saved due to error: ' + angular.toJson(reason));
                    })
                    .finally(() => {
                        this.loadingInProgress = false;
                    })

            } else if (this.selectedSection instanceof SetLocationsSection) {

                let section = this.selectedSection as SetLocationsSection;

                section.preSave();

                this.loadingInProgress = true;

                return this.dataService.customMethodData(`/${this.appSettings.API_ROOT}/${this.baseEndpoint}Leaf`, 'POST', section.serialize())
                    .then(({data}) => {
                        section.model = data;
                        this.mode = Meevo.Model.MaintenanceFormState.Readonly;
                        this.loggingService.trace(`Node locations saved.`);
                        this.postUpdate(section.model);
                        section.takeLocationsBackup();
                    })
                    .catch((reason: any) => {
                        this.loggingService.trace('Item not saved due to error: ' + angular.toJson(reason));
                    })
                    .finally(() => {
                        section.hasChanges = false;
                        section.resetSearch();
                        this.loadingInProgress = false;

                        if (section.fromShortcut) {
                            section.fromShortcut = false;
                            this.activateDesignSection();
                        }
                    })

            } else {
                return super.save();
            }

        }

        initializeHeader(model: any): void {
            this.headerContent = model.displayName;
            this.businessTypeDetail = model.businessTypeDetail;
        }
    }
}
